import { sharedSchema } from "@shared-database/pgSchema";
import { DocumentChunk } from "@shared-database/models/rag/document-chunk";
import { KnowledgeEntity } from "@shared-database/models/rag/knowledge-entity";
import {
  leoID,
  leoNotNullForeignID,
  timestampColumns,
} from "@shared-database/utils";
import type { InferInsertModel, InferSelectModel } from "drizzle-orm";
import { index, uniqueIndex } from "drizzle-orm/pg-core";

/**
 * Join table between reusable file chunks and graph-scoped entities.
 *
 * Rows are produced when profile graph extraction materializes entities for a
 * file. They let retrieval jump from an entity hit back to the exact chunks
 * that mentioned it, while keeping chunk storage itself source-neutral.
 */
export const DocumentChunkEntity = sharedSchema.table(
  "DocumentChunkEntity",
  {
    // Mixins
    ...timestampColumns,

    // Properties
    id: leoID("id"),

    // References
    chunkId: leoNotNullForeignID("chunkId").references(() => DocumentChunk.id, {
      onDelete: "cascade",
    }),
    entityId: leoNotNullForeignID("entityId").references(
      () => KnowledgeEntity.id,
      { onDelete: "cascade" },
    ),
  },
  (table) => [
    uniqueIndex("DocumentChunkEntity_uniqueIdx").on(
      table.chunkId,
      table.entityId,
    ),
    index("DocumentChunkEntity_chunkIdx").on(table.chunkId),
    index("DocumentChunkEntity_entityIdx").on(table.entityId),
  ],
);

// Types
export type DocumentChunkEntityType = InferSelectModel<
  typeof DocumentChunkEntity
>;
export type DocumentChunkEntityInsertType = InferInsertModel<
  typeof DocumentChunkEntity
>;
